import { normalizeStringRegex } from "./regex";

export const objectToArray = (input) => {
  const entries = Object.entries(input);
  entries.forEach((entry) => (entry[0] = +entry[0]));
  return entries;
};

export function translateToString(string) {
  string = string?.replace(/[&/\\#,+()$~@%.'":*?<>{}]/g, "");
  string = string?.replace(/\s/g, "-");
  return string;
}

export const convertStringToUrl = (string) => {
  string = string?.replace(/[&/\\#,+()$~@%.'"‘’`^:*?<>{}]/g, "");
  string = string?.replace(/\s/g, "-");
  string = string.trimStart();
  while (string.indexOf("-") === 0) {
    string = string?.replace("-", "");
  }

  while (string.indexOf("  ") > 0) {
    string = string?.replace("  ", "-");
  }
  while (string.indexOf("--") > 0) {
    string = string?.replace("--", "-");
  }
  return string;
};

export const getShortContent = (str = "", num = 150) => {
  const str_len = str?.length;
  if (str_len > num) {
    return `${str.substring(0, num)}...`;
  }
  return str;
};

export function checkEmptyObject(obj) {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
}

export function normalizeInput(value, previousValue) {
  if (!value) return value;
  const currentValue = value.replace(/[^\d]/g, "");
  const cvLength = currentValue.length;

  if (!previousValue || value.length > previousValue.length) {
    if (cvLength < 4) return currentValue;
    if (cvLength < 7) return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;
    return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`;
  }
}

function getFileNameFromPath(filePath) {
  return filePath.substring(filePath.lastIndexOf("/") + 1);
}

function getShortName(fileName) {
  if (fileName.length > 30) {
    return `${fileName.slice(0, 30)}...${fileName.split(".").pop()}`;
  }
  return fileName;
}

export function getFileName(fileName) {
  if (typeof fileName === "string") {
    if (fileName?.includes("/")) {
      return getShortName(getFileNameFromPath(fileName));
    }
    return getShortName(fileName);
  }
}

export function getFileExtension(filename) {
  return filename?.substring(filename?.lastIndexOf(".") + 1, filename?.length) ?? filename;
}

export function getLastNumOfStr(str = "", n = 4) {
  const len = str.length;
  return str.substring(len - n);
}

export function removeSlashes(s) {
  return s.replace(/\\|\//g, "");
}

export function prepareCProvides(str) {
  const isValidStart = str.startsWith("[{");
  const isValidEnd = str.endsWith("}]");
  try {
    return JSON.parse(removeSlashes(str));
  } catch (err) {
    if (!isValidStart && !isValidEnd) return [];
    if (isValidStart && !isValidEnd) {
      const lastBracket = str.lastIndexOf("}");
      if (lastBracket) {
        return JSON.parse(removeSlashes(`${str.slice(0, lastBracket + 1)}]`));
      }
      return [];
    }
    return [];
  }
  // }
}

export const isImgLink = (url) => {
  if (typeof url !== "string") {
    return false;
  }
  // eslint-disable-next-line no-useless-escape
  return url.match(/^http[^\?]*.(jpg|jpeg|gif|png|tiff|bmp)(\?(.*))?$/gim) !== null;
};

export const convertQuery = (obj) => {
  return Object.keys(obj)
    .filter((x) => obj[x])
    .map((key) => `${key}=${obj[key]}`)
    .join("&");
};

export const objToFormData = (obj) => {
  const formData = new FormData();
  Object.keys(obj)
    // .filter((x) => obj[x])
    .forEach((key) => formData.append(key, obj[key]));
  return formData;
};

export const replaceNull = (obj) => {
  Object.keys(obj).forEach(function (key) {
    if (obj[key] === null) {
      obj[key] = "";
    }
  });
  return obj;
};

export const reorderDND = (option, startIndex, endIndex) => {
  const items = [...option];
  const [reorderedItem] = items.splice(startIndex, 1);
  items.splice(endIndex, 0, reorderedItem);
  return items;
};

export const readingTime = (content) => {
  const wordsPerSecond = 180; // Average case.
  let result = 1;

  const textLength = content.split(" ").length; // Split by words
  if (textLength > 0) {
    result = Math.ceil(textLength / wordsPerSecond);
  }
  return result;
};

export const isObjSame = (obj1, obj2) => {
  return Object.keys(obj1)
    .filter((x) => Object.keys(obj2).includes(x))
    .find((y) => obj1[y]?.toString()?.trim() !== obj2[y]?.toString()?.trim());
};

export const formatTwoDecimals = (str) => {
  const num = parseFloat(str);

  return Math.round(num * 100) / 100;
};
export const deepClone = (obj) => {
  return JSON.parse(JSON.stringify(obj));
};

export const autoScrollComponent = (section, field) => {
  setTimeout(() => {
    const mainContentEl = document.getElementsByClassName("scrollableContentArea")[0];
    const element1 = document.querySelector(`.scrollableContentArea #${field}`);
    const element2 = document.querySelector(`.scrollableContentArea #${section.key}`);

    let scrollTopValue;

    if (mainContentEl && element1) {
      scrollTopValue = element1?.offsetTop;
    } else if (mainContentEl && element2) {
      scrollTopValue = element2?.offsetTop;
    }

    if (mainContentEl && scrollTopValue !== undefined) {
      const containerHeight = mainContentEl.clientHeight;
      const elementHeight = element1 ? element1.clientHeight : element2.clientHeight;

      // Calculate the scroll position to center the element
      const scrollToMiddle = scrollTopValue - ((containerHeight - elementHeight) / 3) * 2;
      mainContentEl.scrollTop = scrollToMiddle;
      // mainContentEl.scrollTop = scrollTopValue;
    }
  }, 300);
};

export const removeHtmlAndBreaks = (value) => {
  const htmlTag = ["<p>", "<div>", "<h1>", "<h2>", "<h3>", "<h4>", "<h5>", "<h6>"];
  const htmlTagEnd = ["</p>", "</div>", "</h1>", "</h2>", "</h3>", "</h4>", "</h5>", "</h6>"];

  let newValue = value
    ?.replace(/<br\s*\/?>/g, "\n") // Replace <br> and <br/> with newline (\n)
    ?.replace(/&nbsp;/g, "");

  htmlTag.forEach((tag, index) => {
    const tagRegex = new RegExp(escapeRegExp(tag), "g");
    const tagEndRegex = new RegExp(escapeRegExp(htmlTagEnd[index]), "g");

    newValue = newValue?.replace(tagEndRegex, "\n");
    newValue = newValue?.replace(tagRegex, "");
  });

  newValue = newValue?.replace(normalizeStringRegex, "");

  return newValue;
};

export const higherPlan = (currenrPlan, nextPlan) => {
  const plans = {
    basic: 1,
    premium_month: 2,
    premium: 3,
    pro_month: 4,
    pro: 5,
  };
  return plans[currenrPlan] < plans[nextPlan];
};

// Helper function to escape special characters in a string for use in a RegExp
function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
}

export function divideArrayEqually(array, numberOfParts) {
  const partSize = Math.floor(array.length / numberOfParts);
  let remainingLength = array.length % numberOfParts;
  const dividedArray = [];
  let lastaddMore = 0;

  for (let i = 0; i < numberOfParts; i++) {
    if (partSize === 0) {
      dividedArray.push([...array]);
    } else {
      const addMore = remainingLength > 0 ? 1 : 0;
      const startIndex = i * partSize + lastaddMore;
      const endIndex = startIndex + partSize + addMore;
      lastaddMore += addMore;
      remainingLength--;
      dividedArray.push(array.slice(startIndex, endIndex));
    }
  }

  return dividedArray;
}

export const scrollToElementById = (id) => {
  setTimeout(() => {
    const element = document.getElementById(id);
    if (element) {
      window.scrollTo({
        top: element.offsetTop,
        behavior: "smooth",
      });
    }
  }, 300);
};

export const getMaxDate = () => {
  const maxDate = new Date();
  maxDate.setFullYear(maxDate.getFullYear() - 13);
  return maxDate;
};

export const addTargetBlank = (className) => {
  const elements = document.querySelectorAll(`.${className}`);
  elements.forEach((element) => {
    const anchorTags = element.getElementsByTagName("a");
    for (const anchor of anchorTags) {
      anchor.setAttribute("target", "_blank");
      const href = anchor.getAttribute("href");
      // Check if the href starts with "www."
      if (href?.startsWith("www.")) {
        // Add "https://" to the beginning of the href attribute
        anchor.setAttribute("href", `https://${href}`);
      }
    }
  });
};

export function removeHtmlTagsAndReplaceNbsp(inputString) {
  const stringWithoutHtmlTags = inputString.replace(/<[^>]*>/g, "");
  return stringWithoutHtmlTags.replace(/&nbsp;/g, " ");
}

export const getEstDate = () => new Date(new Date().toLocaleString("en-US", { timeZone: "America/New_York" }));

export const greaterDate = (date, time) => {
  const datetimeStr = `${date} ${time}`;
  const inputDate = new Date(datetimeStr);
  const currentDate = getEstDate();
  return inputDate > currentDate;
};

export const preventPropogation = (className) => {
  const anchorTags = document.querySelectorAll(`.${className} a`);
  anchorTags.forEach(function (anchorTag) {
    anchorTag.onclick = function (e) {
      e.stopPropagation();
    };
  });
};

export const preventAnchorTags = (className) => {
  const anchorTags = document.querySelectorAll(`.${className} a`);
  anchorTags.forEach(function (anchor) {
    anchor.addEventListener("click", function (event) {
      event.preventDefault();
    });
  });
};

export function removeTrailingColon(str) {
  if (str.endsWith(":")) {
    return str.slice(0, -1);
  }
  return str;
}

export function showFixedLength(str, length) {
  if (str) {
    return str?.substring(0, length);
  }
  return "";
}

export function stringLength(str, length) {
  if (str?.length >= length) {
    return "...";
  }
  return "";
}

export function isHTML(str) {
  // Check if the string contains HTML tags
  return /<[a-z][\s\S]*>/i.test(str);
}

export function addCommasToNumber(number) {
  // Convert the number to a string
  let numberString = number.toString();

  // Use regular expression to add commas after every three digits from the right
  numberString = numberString.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return numberString;
}

export function removeCommasFromString(string) {
  // Use the replace method with a regular expression to remove all commas
  return string.replace(/,/g, "");
}

export function noteNameRegex(name) {
  return name
    .replace(/^ +/, "") // Remove spaces at the beginning
    .replace(/ {2,}/g, " ") // Replace 2 or more consecutive spaces with a single space
    .replace(/[^a-z0-9 ]/gi, ""); // Remove any characters that are not letters, numbers, or spaces
}

export function removeCommasFromDate(dateStringWithCommas, dateFormat) {
  if (dateStringWithCommas) {
    const dateRegex = dateFormat === "DD MMMM, YYYY";
    if (!dateRegex) {
      return dateStringWithCommas;
    }
    const parts = dateStringWithCommas?.split(" ");

    parts[1] = parts[1]?.replace(",", "");
    return parts?.join(" ");
  }
}

export const calculateDaysRemaining = (date) => {
  const endDateTime = new Date(date);
  const currentDateTime = new Date();
  const millisecondsPerDay = 24 * 60 * 60 * 1000;
  const remainingDays = Math.ceil((endDateTime - currentDateTime) / millisecondsPerDay);

  return remainingDays;
};

export function removeTrailingSlashes(str) {
  return str.replace(/\/+$/, "");
}

export function convertSpaceToHyphen(inputString) {
  // Replace spaces with hyphens
  let formattedString = inputString?.replace(/ /g, "-");

  // Remove periods and commas
  formattedString = formattedString?.replace(/[.,?:]/g, "");

  return formattedString;
}
